const COOL_OFF = {
  GET_COOL_OFFS: 'risk/cooloffs-get' as 'risk/cooloffs-get',
  ADD_COOL_OFF: 'risk/cooloffs-temporarily' as 'risk/cooloffs-temporarily',
  GET_CATEGORIES: 'games/get-game-categories' as 'games/get-game-categories',
  GET_PERIODS_AND_AMOUNTS: 'basic-get' as 'basic-get',
  DELETE_COOL_OFF: 'risk/cooloffs-admin-delete' as 'risk/cooloffs-admin-delete'
}

export default COOL_OFF
